import { createContext, useContext, useState, useCallback } from "react";

const Ctx = createContext({ open: () => {}, close: () => {}, isOpen: false, answers: {}, setAnswer: () => {}, toolkitOpen: false, openToolkit: () => {}, closeToolkit: () => {} });

export const DiagnosticProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [toolkitOpen, setToolkitOpen] = useState(false);
  const [answers, setAnswers] = useState({});
  const setAnswer = useCallback((k, v) => setAnswers((a) => ({ ...a, [k]: v })), []);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const openToolkit = useCallback(() => { sessionStorage.setItem("aor_popup_seen", "1"); setToolkitOpen(true); }, []);
  const closeToolkit = useCallback(() => setToolkitOpen(false), []);
  return <Ctx.Provider value={{ isOpen, open, close, answers, setAnswer, setAnswers, toolkitOpen, openToolkit, closeToolkit }}>{children}</Ctx.Provider>;
};

export const useDiagnostic = () => useContext(Ctx);
